import type { PaginatedMetadataTemplateList } from '@openapi'
import type { GetInstanceMetadataTemplatesPayload } from '@sdk/payload.types'
import { ADMIN_API_METHOD_TYPES } from '@lib/sdk/api/modules/admin/types.admin'
import { usePostRobot } from '@lib/sdk/utils/postrobot'

/**
 * Fetches a list of metadata templates to use in your app. Instance is auto-injected by admin app if in instance scope.
 *
 * @example
 * adminApi.getInstanceMetadataTemplates()
 **/
export async function getInstanceMetadataTemplates(
  payload?: GetInstanceMetadataTemplatesPayload,
): Promise<PaginatedMetadataTemplateList> {
  const pr = await usePostRobot()
  const response = await pr.send(window.parent, ADMIN_API_METHOD_TYPES.GET_INSTANCE_METADATA_TEMPLATES, payload)
  return <PaginatedMetadataTemplateList>response.data
}
